export default __webpack_public_path__ + "static/media/cargill-frame-interface.38f67f9e.png";